<template>
  <div>
    <div class="row">
      <div class="col_12">
          <div class="card no_border">
            <div class="card-header">
                <div class="card-title">{{ $t('sidebar.orderManagement.orderManagement') }}</div>
            </div>
            <div class="card-body pl_0 pr_0">
              <div class="row">
                <div class="col_2">
                  <div class="form-group ">
                    <label></label>
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                          <button class="btn">
                            <span>{{ filter2.order_status }}</span>
                          </button>
                          <div class="dropdown_menu">
                            <ul>
                              <li @click="changeStatusFilter('all')"><a role="button">{{ $t('common.all') }}</a></li>
                              <li @click="changeStatusFilter('pending')"><a role="button">{{ $t('sidebar.orderManagement.pending') }}</a></li>
                              <li @click="changeStatusFilter('accepted')"><a role="button">{{ $t('sidebar.orderManagement.accepted') }}</a></li>
                              <li @click="changeStatusFilter('rejected')"><a role="button">{{ $t('sidebar.orderManagement.rejected') }}</a></li>
                              <li @click="changeStatusFilter('refunded')"><a role="button">{{ $t('sidebar.orderManagement.refunded') }}</a></li>
                              <li @click="changeStatusFilter('partially-refunded')"><a role="button">{{ $t('sidebar.orderManagement.partiallyRefunded') }}</a></li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_10">
                  <div class="form-group ">
                    <label></label>
                    <div class="d_flex_end">
                      <div class="form_row_inline ml_10">
                        <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                      </div>
                      <div class="form_row_inline ml_10">
                        <div class="btn btn_common_type_2 width_150p" @click="queryParams.page = 1 ; searchQuery()">{{ $t('common.search') }}</div>
                      </div>
                      <div class="form_row_inline ml_10">
                        <div class="btn btn_common_type_2 width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col_12 ">
                      <div class="separator pl_0 pr_0">
                          <span></span>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col_12">
                    <div class="d_flex_btwn pt_20 pb_20">
                        <div class="d_flex_start col_2 pl_0">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter.per_page }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                      <li @click="changeFilter(10)"><a role="button">10</a></li>
                                      <li @click="changeFilter(20)"><a role="button">20</a></li>
                                      <li @click="changeFilter(50)"><a role="button">50</a></li>
                                      <li @click="changeFilter(100)"><a role="button">100</a></li>
                                      <li @click="changeFilter(200)"><a role="button">200</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <table-component 
                  :columns="columns"
                  :rows="orders"
                  :pagination="pagination"
                  @sorting="sorting"
                  :sortable="sortable"
                  @pageChanged="pageChanged">
                  <template #amount_formated="{ row }">
                    {{ row.amount_formated }} 원
                  </template>
                  <template #action="{ row }">
                    <div class="d_flex_center table_action_btn">
                      <router-link :to="{name: 'order_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                        <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                      </router-link>
                      <button v-if="row.order_status == 'accepted'" class="btn btn_info ml_10" title="환불" @click.prevent="refundConfirmation(row)">
                        <img :src="`${baseUrl}assets/media/images/icon/refund.png`" alt="">
                      </button>
                      <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                        <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                      </button>
                    </div>
                  </template>
              </table-component>
            </div>
          </div>
      </div>
    </div>
    <refund-confirmation-modal
      v-if="showRefundConfirmationModal"
      :openRefundConfirmationModal="showRefundConfirmationModal"
      :packageRefundAmount="packageRefundAmount"
      @submitRefundConfirmation="submitRefundConfirmation"
      @closeRefundConfirmationModal="closeRefundConfirmationModal"
    ></refund-confirmation-modal>
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";
import RefundConfirmationModal from './RefundConfirmationModal';
export default {
  components: {TableComponent,RefundConfirmationModal},
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      orders: [],
      filter: {
        order_status: '',
        per_page: 20
      },
      filter2: {
        order_status: this.$t('common.all'),
        per_page: 20
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'order_number,package_name,package_code,parent.name,student.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: this.$t('sidebar.orderManagement.order_number'),
          field: "order_number",
          sortable: true
        },
        {
          label: this.$t('sidebar.packageManagement.package_name'),
          field: "package_name",
          sortable: true
        },
        {
          label: this.$t('sidebar.packageManagement.package_code'),
          field: "package_code",
          sortable: true
        },
        {
          label: this.$t('sidebar.parentMember.parent_name'),
          field: "parent.name",
          sortable: false
        },
        {
          label: this.$t('sidebar.orderManagement.student_name'),
          field: "student.name",
          sortable: false
        },
        {
          label: this.$t('sidebar.orderManagement.order_status'),
          field: "formatted_order_status",
          sortable: false
        },
        {
          label: this.$t('sidebar.orderManagement.ordered_at'),
          field: "ordered_at",
          sortable: true,
        },
        {
          label: this.$t('sidebar.orderManagement.expired_at'),
          field: "expired_at",
          sortable: true,
        },
        {
          label: this.$t('sidebar.orderManagement.amount'),
          field: "amount_formated",
          sortable: false,
          slot:true
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      showRefundConfirmationModal: false,
      packageRefundAmount: '',
      packageOrderId: ''
    }
  },
  watch: {
    $route(to, from) {
        if(to.name == from.name && !window._.isEqual(to, from)){
          this.setQueryData(this.getAllQueryParams())
          this.loadData()
        }
      },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }

    this.loadData();
  },
  methods: {
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        order_status: query.order_status,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    resetAll(){
      this.sortable = {
          order: 'created_at',
          sort: 'desc'
      }
      this.filter = {
        order_status: '',
        per_page: 20
      }
      this.filter2 = {
        order_status: this.$t('common.all'),
        per_page: 20
      }

      this.queryParams = {
          page: 1,
          search: '',
          search_columns: 'order_number,package_name,package_code,parent.name,student.name',
          sort: 'created_at',
          sort_order: 'desc',
          per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery(){
        this.changeRoute();
    },
    sorting({column, order}) {
        this.queryParams.sort = column;
        this.queryParams.sort_order = order;
        this.queryParams.page = 1;
        this.changeRoute()
    },
    pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
    },
    changeStatusFilter(status){
      if(status == 'all'){
        this.filter.order_status = ''
        this.filter2.order_status = this.$t('common.all')
      }else{
        let statusName = '';

        if(status == 'pending'){
          statusName = this.$t('sidebar.orderManagement.pending')
        }else if(status == 'accepted'){
          statusName = this.$t('sidebar.orderManagement.accepted')
        }else if(status == 'rejected'){
          statusName = this.$t('sidebar.orderManagement.rejected')
        }else if(status == 'refunded'){
          statusName = this.$t('sidebar.orderManagement.refunded')
        }else if(status == 'partially-refunded'){
          statusName = this.$t('sidebar.orderManagement.partiallyRefunded')
        }
        this.filter.order_status = status
        this.filter2.order_status = statusName
      }
      this.changeRoute();
    },
    changeFilter(per_page){
      this.filter.per_page = per_page
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/orders', {
            params: {...this.queryParams, ...this.filter}
        }).then((response) => {
            this.orders = response.data.data;
            this.pagination = response.data.meta;
        })
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/orders/'+row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            )
          });
        }
      });
    },
    refundConfirmation(row){
      this.packageOrderId = row.id
      this.packageRefundAmount = row.amount
      this.showRefundConfirmationModal = true
    },
    closeRefundConfirmationModal(){
      this.packageOrderId = ''
      this.packageRefundAmount = ''
      this.showRefundConfirmationModal = false
    },
    submitRefundConfirmation(form_data) {
      this.showRefundConfirmationModal = false
        this.$swal({
            title: '정말 주문을 취소하겠습니까?',
            text: '취소한 주문은 다시 되돌릴 수 없습니다. 그대로 진행하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '예',
            cancelButtonText: '아니오',
            confirmButtonColor: '#00B4FF',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
              this.axios.post('/order-refund/'+this.packageOrderId, form_data)
              .then((response) => {
                if(response.data.success){
                  this.loadData();
                  this.$swal.fire(
                    '환불완료',
                    '결제가 성공적으로 환불되었습니다.',
                    'success'
                  )
                }else{
                  this.$swal({
                    title: '문제가 발생했습니다.',
                    text: this.$t(response.data.message),
                    icon: "warning",
                  });
                }
              });
            }
        });
    },
  }
}
</script>